import { Button, CheckCircleIcon, ChevronDownIcon, XCircleIcon } from "@";
import { VerificationStageStatus } from "@/features/operations/verifications/types.ts";

type DropdownOptionsProps = {
  selectedIds: number[];
  selectedStatuses: VerificationStageStatus[];
  isReturning: boolean;
  isUnassigning: boolean;
  handleReturnToDriver: () => void;
  handleUnassignDriver: () => void;
  selectingAll: boolean;
  totalItems: number;
};

export default function DropdownOptions({
  selectedIds,
  selectedStatuses,
  isReturning,
  isUnassigning,
  handleReturnToDriver,
  handleUnassignDriver,
  selectingAll,
  totalItems,
}: DropdownOptionsProps) {
  const selectedCount = selectingAll ? totalItems : selectedIds.length;

  // Check if all selected statuses are Verified
  const isAllVerified =
    selectedIds.length > 0 &&
    selectedStatuses.every((status) =>
      [
        VerificationStageStatus.Verified,
        VerificationStageStatus.WaitingSendingTime,
      ].includes(status),
    );

  const isAllUnassigned =
    selectedIds.length > 0 &&
    selectedStatuses.every((status) =>
      [
        VerificationStageStatus.Assigned,
        VerificationStageStatus.NotStarted,
        VerificationStageStatus.Rejected,
        VerificationStageStatus.ProcessingFiles,
      ].includes(status),
    );

  return (
    <>
      <button
        type="button"
        disabled={selectedCount <= 0 || (!isAllVerified && !isAllUnassigned)}
        id="verify-actions-dropdown-btn"
        data-dropdown-toggle="verify-actions-dropdown"
        className="btn-outline-red flex items-center gap-1"
      >
        إلغاء التوثيق / الإسناد
        {selectedCount > 0 && (isAllVerified || isAllUnassigned) && (
          <ChevronDownIcon className="h-4 w-4" />
        )}
      </button>

      <div
        id="verify-actions-dropdown"
        className="z-10 hidden w-56 overflow-hidden rounded-2xl border bg-white shadow-lg dark:border-gray-700 dark:bg-gray-800"
      >
        <ul
          className="flex flex-col divide-y divide-gray-200 text-sm font-medium"
          aria-labelledby="verify-actions-dropdown-btn"
        >
          <li>
            <Button
              type="button"
              isLoading={isReturning}
              title="إلغاء توثيق الطلبات"
              onClick={handleReturnToDriver}
              className="btn-gust w-full items-center justify-start text-red-500"
              disabled={!selectedIds.length || !isAllVerified}
            >
              <CheckCircleIcon className="h-6 w-6" />
            </Button>
          </li>

          <li>
            <Button
              type="button"
              isLoading={isUnassigning}
              title="إلغاء إسناد الطلبات"
              onClick={handleUnassignDriver}
              className="btn-gust w-full items-center justify-start text-red-500"
              disabled={!selectedIds.length || !isAllUnassigned}
            >
              <XCircleIcon className="h-6 w-6" />
            </Button>
          </li>
        </ul>
      </div>
    </>
  );
}
